import { CloudDownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

export const ImportButton = (args) => {
  return (
    <Button size="small" {...args} icon={<CloudDownloadOutlined />}>
      {args.title || $t("Import")}
    </Button>
  );
};
